import { Box, Button, Grid } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import TargetSelector from "../../components/organisms/targetSelector/TargetSelector";
import DataProvisioningWorkflow from "../../components/organisms/dataProvisioningWorkflow/dataProvisioningWorkflow";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
    getRoleClaimsSelector,
  } from "../../store/auth/selectors";

const DataTargetList = () => {
    const roles = useSelector(getRoleClaimsSelector); // roles  - IDP.Admin or IDP.User
    const [isAdmin, setIsAdmin] = useState(true);

    useEffect(() => {
        if (roles && roles.length > 0) {
          setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
      }, [roles]);


    return (
        <>
            <Box sx={{ paddingBottom: "10px", }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <h1 style={{ textAlign: "left" }}>Data Targets </h1>
                    </Grid>
                </Grid>
            </Box>
            <div style={{ marginBottom: '200px' }}>
                <TargetSelector isAdmin={isAdmin} />
            </div>
            <DataProvisioningWorkflow />
        </>
    )
}

export default DataTargetList;